import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { chain, keys } from 'lodash';
import moment = require('moment');
import { isMoment } from 'moment';
import { AuthService } from '../../security/authorization/auth.service';
import { RolesAware } from '../../../domain/authorization/roles-aware.class';
import { UserAware, UserAwareBase } from '../../../domain/model/user/user-aware.class';
import { ProfileStatusService } from '../service/profile-status.service';
import { ProfileStatusModel, ProfileStatusType, ProfileStatusInteractionModel } from '../model/profile-status.model';
import { Option } from '../../../components/forms/controls/selector/selector.component';

@Component({
    selector: 'my-profile-status',
    template: require('./profile-status.component.html'),
    styles: [require('./profile-status.component.scss')],
    host: {
        '[class.open]' : 'open',
    },
})
export class ProfileStatusComponent extends RolesAware(UserAware(UserAwareBase)) implements OnInit {
    public errors: Error | undefined;
    public loading: boolean = false;
    public model: ProfileStatusInteractionModel;
    public open: boolean = false;
    public statusTypes: Array<Option>;
    private subscriptions: Subscription;

    constructor(
        readonly authService: AuthService,
        readonly profileStatusService: ProfileStatusService
    ) {
        super(authService);
        this.subscriptions = new Subscription();
        this.statusTypes = keys(ProfileStatusType)
            .map(statusType => new Option(statusType, chain(statusType).lowerCase().startCase().value()));
    }

    ngOnInit(): void {
        this._getProfileStatus();
    }

    private _getProfileStatus(): void {
        this.loading = true;
        this.subscriptions.add(
            this.profileStatusService
                .getCurrentUserProfileStatus()
                .subscribe((response: ProfileStatusModel) => {
                    this.loading = false;
                    this.errors = undefined;
                    this.model = {
                        completionDate: response.completionDate ? moment(response.completionDate) : undefined,
                        expirationDate: response.expirationDate ? moment(response.expirationDate) : undefined,
                        notes: response.notes,
                        recredentialDate: response.recredentialDate ? moment(response.recredentialDate) : undefined,
                        recredentialed: response.recredentialed,
                        startDate: response.startDate ? moment(response.startDate) : undefined,
                        status: response.status,
                    };
                }, err => {
                    this.errors = err;
                    this.loading = false;
                })
        );
    }

    private _saveProfileStatus(payload): void {
        this.loading = true;
        this.subscriptions.add(
            this.profileStatusService
                .setCurrentUserProfileStatus(payload)
                .subscribe(() => {
                    this.loading = false;
                    this.errors = undefined;
                    this._getProfileStatus();
                }, err => {
                    this.errors = err;
                    this.loading = false;
                })
        );
    }

    public toggle(event: Event): void {
        event.preventDefault();
        this.open = !this.open;
    }

    public recredentialedChange(checked: boolean) {
        if (!checked) {
            this.model.recredentialDate = undefined;
        }
    }

    public saveProfileStatus(): void {
        const {
            status,
            startDate,
            completionDate,
            expirationDate,
            notes,
            recredentialDate,
            recredentialed,
        } = this.model;
        const payload = {
            status,
            startDate: startDate && isMoment(startDate) ? startDate.toISOString() : startDate,
            completionDate: completionDate && isMoment(completionDate) ? completionDate.toISOString() : completionDate,
            expirationDate: expirationDate && isMoment(expirationDate) ? expirationDate.toISOString() : expirationDate,
            notes,
            recredentialDate: recredentialDate && isMoment(recredentialDate) ? recredentialDate.toISOString() : recredentialDate,
            recredentialed,
        };
        this._saveProfileStatus(payload);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/profile-status/components/profile-status.component.ts